export default {
    extensions: [],
    selectedextension: {},
    totalextensions: [],
    extensionsorders: [],
    extensionsrequests: [],
    getextensionsrequests:[]
}